export class CityAndZip {
    settlements?:Settlements[];
    budapestStreets?: BudapestStreets[];
    debrecenStreets?: DebrecenStreets[];
    gyorStreets?:GyorStreets[];
    miskolcStreets?:MiskolcStreets[];
    pecsStreets?: PecsStreets[];
    szegedStreets?: SzegedStreets[];

}

export class BudapestStreets {
    district?:string;
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;

}

export class DebrecenStreets {
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;
}
export class GyorStreets {
    cityPart?:string;
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;
}
export class MiskolcStreets {
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;
}
export class PecsStreets {
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;
}
export class Settlements {
    zipCode?:number;
    city?:string;

}
export class SzegedStreets {
    cityPart?:string;
    numberFrom?:number;
    numberTo?:number;
    streetName?:string;
    streetType?:string;
    zipCode?:number;
    city?:string;
}
